const APPLE_PLATFORM_RE = /mac|iphone|ipad|ipod/i;

export const isMacPlatform = (platform: string = globalThis.navigator?.platform ?? '') =>
  APPLE_PLATFORM_RE.test(platform);
